import { render, staticRenderFns } from "./CardWorkarea.vue?vue&type=template&id=4093a698"
import script from "./CardWorkarea.vue?vue&type=script&lang=js"
export * from "./CardWorkarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports